import React, { useState, useEffect, useCallback, useRef,useContext } from 'react';
import _ from "lodash";
import {IProps} from './types';
import * as S from './styles';
import { default as D } from '@assets/themes/dimensions';
import Loading from '@components/Loading';
import { SearchIcon } from '@assets/icons/searchIcon';
import { CloseIcon } from '@assets/icons/closeIcon';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@state/actions';
import selectors from '@state/selectors';
import { DesignsContext } from '@utils/DOIgnition/DesignsContext';
import { AuthContext } from '@utils/DOIgnition/AuthContext';

const Search:React.FC<IProps> = (props) => {
  const{ searching, setSearching, setSearchValue, setSearchSelectedOne, 
         setSearchSelectedAll, getQuerySearchByFolder, searchFolder, 
         cleanFilters, setSortByQuery, sharedFiles } = useContext(DesignsContext);
  const [fetchingSearch, setFetchingSearch]= useState(false);
  const [showMenu, setShowMenu]= useState(false);
  const [showLoading, setShowLoading]= useState(false);
  const [showClear, setShowClear]= useState(false);
  const [value, setValue] = useState('');
  const [newSearch, setNewSearch] = useState(false);
  const componentRef = useRef(null);
  const dispatch = useDispatch();
  const searches = useSelector(selectors.designs.getDesignSearch);
  const authContext = useContext(AuthContext);
  
  const fetchSearch = (value: string, searchByFolder: string, sharedFilesInfo: any) => {
    const userData = {
      email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
      name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
    };
    
    let permissions = sharedFilesInfo?.open ? `and ARRAY_CONTAINS(c.usersPermission, {"email": "${userData.email}", "permission": ${sharedFilesInfo?.permission}}) `:'';
    let user = sharedFilesInfo?.open ? `` : `c.createdBy.email='${userData.email}' and`;
    searchByFolder = sharedFilesInfo?.open ? '' : searchByFolder;
    
    let filters = encodeURIComponent(`${user} c.designStatus<>'INACTIVE' and ${searchByFolder}(c.formatName LIKE "%${value.toLowerCase()}%" or udf.searchCustomTagsDesign(c.tags.customTags, "${value.toLowerCase()}")) ${permissions}`);
    let searchQuery=`${filters} &orderby=c.name&start=0&pagelength=20`;
    return new Promise((resolve, reject) => {
      dispatch(actions.designs.fetchSearchDesigns('?filter='+searchQuery,(result, error) => {
        if (error) reject(error)
        else resolve(result)
      }))
    });
  }

  const debounce  = useCallback(
    _.debounce((_searchVal: string, _searchValFolder: string, _sharedFilesInfo: any) => {
      const run = async () => {
        await fetchSearch(_searchVal, _searchValFolder, _sharedFilesInfo);
      }
      run();	
    }, 400),
    []
  );
  
  const handleClickOuside = (e: any)=> {
    if(componentRef && componentRef.current){
        const ref: any = componentRef.current
        if(!ref.contains(e.target)){
          setShowMenu(false);
        }
    }
  }

  useEffect(() => {
    document.addEventListener("click", handleClickOuside);
    return () => document.removeEventListener("click", handleClickOuside);
  }, []);

  useEffect(() => {
    if((searches)&&(value!=='')){
      setShowLoading(false);
      setNewSearch(true);
      setSearchSelectedAll(false)
      if(value.length>3)setFetchingSearch(false);
    }
    else{
      setShowMenu(false);
      setShowLoading(false);
    }
  }, [searches]);

  useEffect(() => {
    if (searchFolder){
      if (value!=='') {
        setValue('');
        setShowClear(false);
      }
    }
  }, [searchFolder]);

  useEffect(() => {
    if (!searching){
      if (value!=='') {
        setValue('');
        setShowClear(false);
      }
    }
  }, [searching]);

  const handleFocus=()=> {
    if((searches)&&(value.length>3))setShowMenu(true);
  };

  const handleChange = (event: any) => {
    setValue(event.target.value);

    if(event.target.value.length>0)setShowClear(true);
    else setShowClear(false);
    
    if(event.target.value.length>3){
      setFetchingSearch(true);
      setShowLoading(true);
      setShowMenu(true);
      debounce(event.target.value, getQuerySearchByFolder(''), sharedFiles);
    }
    
    if(event.target.value.length==0)setShowMenu(false);
  };
  
  const handleClear = (event: any) => {
    setShowMenu(false);
    setValue('');
    setShowClear(false);
    clearSearch(); 
  }

  const clearSearch=()=>{
    setSearching(false);
    setSearchValue('');
  }

  const handleKeyUp=(e:any)=>{
    if (e.keyCode === 8) { 
      if(e.target.value.length===0)clearSearch();
    }
    else if (e.keyCode === 13) {
      if(searches && value.length>3){
        if (searches.length>0 && !fetchingSearch){
          setSortByQuery('');
          setShowMenu(false);
          setSearching(true);
          setSearchSelectedOne(null);
          setSearchSelectedAll(true);
          cleanFilters();
          setSearchValue(value);
        }
      }
    }
  }

  const handleClickOption = (event: any, idx:number) => {
    setSearching(true);
    setSearchSelectedAll(false);
    setSearchSelectedOne(searches[idx]);
    setShowMenu(false);
  }

  let width=`calc(44vw - ${D.VERTICAL_MENU_WIDTH + D.LOGOUT_WIDTH}px)`;

  return (
    <S.Root ref={componentRef}>
      <SearchIcon style={{display: 'inline-block', verticalAlign: 'middle', marginLeft: '27px'}}/>
      <S.Col style={{width: width }}>
          <S.InputSearch 
            id="search"
            placeholder="Search Designs..."
            value={value}
            onChange={handleChange}
            onFocus={ handleFocus }
            onClick={ ()=>handleFocus()}
            onKeyUp={(e)=>handleKeyUp(e)} 
            autoComplete="off"
          />
          {showClear &&
          <S.Icon onClick={(e)=>handleClear(e)}>
            <CloseIcon/>
          </S.Icon>}
      </S.Col>
      <S.SearchList style={{display: showMenu?'block':'none'}}>
          <S.OptionsContaine>
              {(searches&&(value.length>3)&&(!showLoading)) && searches.map((design: any, idx: number)=>{

                let tag=null;
                if (!design.formatName.includes(value)){
                  design.tags.customTags.forEach((item: string)=>{
                    if (item.includes(value.toLowerCase()))tag=<S.Tag>- Tag: {item}</S.Tag>
                  })
                }

                return <S.Option key={`op${idx}`} onClick={(e)=>handleClickOption(e, idx)}>
                         {design.name}
                         {tag}
                      </S.Option>
              })}
              {searches && searches.length===0 && !showLoading &&
                <S.Option>No designs found for your search.</S.Option>
              }
          </S.OptionsContaine>
          {showLoading && <Loading/>}
        </S.SearchList>
    </S.Root>
  );
}

export default Search;